import React from "react";

import "./cook-time.m.css";

const CookTime = ({ cookTime, ...rest }) => {
  if (!cookTime) return null;
  return (
    <div styleName="cook-time" {...rest}>
      Cook time: {cookTime}
    </div>
  );
};

export default CookTime;
